var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramMobileDiagonalArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 26,
  viewBox: "0 0 26 26",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13 0c7.18 0 13 5.82 13 13s-5.82 13-13 13S0 20.18 0 13 5.82 0 13 0m4.247 8h-6.494a.75.75 0 1 0 0 1.5h4.743l-6.782 6.782a.745.745 0 0 0-.066.971l.072.084a.744.744 0 0 0 1.055.006l6.725-6.726v4.636c0 .372.282.69.648.74l.102.007.102-.007a.746.746 0 0 0 .648-.74V9.247a.7.7 0 0 0-.044-.25A.7.7 0 0 0 18 8.75l-.007-.102A.75.75 0 0 0 17.247 8"
})));
export default SvgInstagramMobileDiagonalArrow;